export default __webpack_public_path__ + "static/media/Crispine Ngena.15f1acc8.JPG";